import Link from '../../components/common/util/input/Link'

const ImprintPage = (props) => {
    const defClass = 'flex mb-4 text-xl'

    return (
        <div className={'Page'}>
            <div className={'px-4 pt-4 mb-4'}>
                <div className={'w-full justify-start'}>
                    <div className={defClass}>
                        • New Market, Inventory Views and Filters are live
                    </div>
                    <div className={defClass}>
                        • Template Buy Offers fully integrated - We also have a
                        Buy Offer Search, which is unique:{' '}
                        <Link href={'/buyoffers'}>
                            <div className={'text-primary ml-2'}> here</div>
                        </Link>
                    </div>
                    <div className={defClass}>
                        • New Trade View is currently being worked on
                    </div>
                    <div className={defClass}>
                        • Light Mode is being worked on
                    </div>
                    <div className={defClass}>
                        • Some Progress on scalable Database Model
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImprintPage
